import { Theme, makeStyles, createStyles } from '@material-ui/core';
import { darken } from '@material-ui/core/styles';
import { BrandColors } from '../../constants/brandColors';

export const TipsStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      width: '100%',
      minHeight: 'inherit',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      background: theme.palette.background.paper,
      alignItems: 'center',
      justifyContent: 'center',
    },
    screenContent: {
      width: '100%',
      minWidth: '12.5rem',
      maxWidth: '35rem',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flexGrow: 1,
      padding: '0 2rem 1rem',
      textAlign: 'left',
      position: 'relative',
      [theme.breakpoints.up('md')]: {
        maxWidth: '62.5rem',
      },
    },
    infoScreenWrapper: {
      maxWidth: '28.25rem',
      position: 'relative',
      marginTop: '5.9%',
      marginBottom: '5.9%',
      flexGrow: 1,
      width: '100%',
      [theme.breakpoints.up('md')]: {
        maxWidth: '42.5rem',
      },
    },
    infoScreenLayout: {
      width: '100%',
      minHeight: '100%',
    },
    iconBox: {
      margin: 'auto auto 1.5rem',
      marginBottom: '3.5rem',
      width: '11.5rem',
      height: '11.5rem',
      minHeight: '11.5rem',
      [theme.breakpoints.up('md')]: {
        width: '12.5rem',
        height: '12.5rem',
        position: 'absolute',
        left: 0,
        top: 0,
      },
    },
    infoText: {
      paddingLeft: 0,
      [theme.breakpoints.up('md')]: {
        paddingLeft: '15.5rem',
      },
    },
    infoHeading: {
      fontSize: '2rem !important',
      marginBottom: '2.5rem',
      lineHeight: '2.25rem',
      fontWeight: 600,
      color: theme.palette.default?.main || BrandColors.grey41,
      marginTop: 0,
      fontFamily: 'Open Sans,sans-serif',
    },
    instructions: {
      fontSize: '1.125rem !important',
      marginBottom: '1.25rem',
      lineHeight: 1.5,
      color: theme.palette.default?.main || BrandColors.grey41,
      marginTop: 0,
      fontFamily: 'Open Sans,sans-serif',
    },
    tipsButtonOffset: {
      bottom: 0,
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      marginTop: '2rem',
      height: '5rem !important',
      [theme.breakpoints.up('md')]: {
        position: 'relative',
        top: 0,
        left: 0,
        paddingLeft: '15.5rem',
        justifyContent: 'flex-start',
      },
    },
    tipsButton: {
      maxWidth: '100%',
      backgroundColor: theme.palette.primary.contrastText,
      color: theme.palette.background.paper,
      marginTop: '1.5rem',
      borderRadius: '3.75rem',
      fontSize: '1.125rem',
      lineHeight: '1.75rem',
      letterSpacing: '.05em',
      width: '100%',
      height: '5rem',
      '&:hover': {
        backgroundColor: darken(theme.palette.primary.contrastText, 0.2),
      },
      [theme.breakpoints.up('md')]: {
        maxWidth: '16rem',
      },
    },
    screenManager: {
      position: 'absolute',
      width: '100%',
      zIndex: 250,
      height: 'calc(100vh - 2.5rem)',
      [theme.breakpoints.up('md')]: {
        height: 'calc(100vh - 3.125rem)',
      },
      '& .thankYouScreen': {
        position: 'fixed',
        overflow: 'auto',
        width: '100%',
        height: '100%',
        zIndex: 251,
      },
    },
    exitScreen: {
      position: 'fixed',
      overflow: 'auto',
      width: '100%',
      height: '100%',
      zIndex: 253,
    },
    show: {
      display: 'block',
      minHeight: 'inherit',
    },
    hide: {
      display: 'none',
    },
  }),
);
